import { Type } from 'class-transformer';
import { ActivityDetailResultDto } from './activity-detail-result-dto';

export class ActivityFeedResultDto {
  communityId: number;
  customerId: string;
  propertyAddress: string;
  description: string;
  code: string;
  @Type(() => Date)
  activityDate: Date;
  @Type(() => ActivityDetailResultDto)
  details: Array<ActivityDetailResultDto>;
}
